<article class="validate-phone-form-wrapper">

  <ng-container *ngIf="!showChangeMethodCode">
    <h2 class="text">Ingresa el código que recibiste vía {{ sendMethod || getEmailTargetText()}}</h2>
    <h4 class="sub-title">Se envío al {{ isEmailTarget() ? 'correo' : 'número' }} {{ target }}</h4>
    <span class="secondary-text">Puede tardar algunos segundos.</span>
    <form [formGroup]="smsValidationForm" class="sign-up-form" autocomplete="off" *ngIf="!showWhatsApp">
      <section class="token-form">
        <div class="form-group token">
          <input type="text" class="form-control" aria-describedby="Token" placeholder="Código de validación" maxlength="6" formControlName="token" [id]="idPrefix + 'validate-phone-token'" (keyup.enter)="validate()" autocomplete="off">
        </div>
      </section>

      <section>
        <app-error-message [error]="message"></app-error-message>
      </section>

      <section class="">
        <app-button class="code-app-button" [title]="'Continuar'" [isDisabled]="!smsValidationForm.valid" [customClasses]="'main full-width sign-up-button'" [isLoading]="isLoading" [buttonId]="idPrefix + 'validate-phone-validate'" (click)="validate()"></app-button>

        <app-button class="code-app-button" [title]="'Reenviar'" [isDisabled]="reSendDisabled" [customClasses]="'main full-width sign-up-button'"  [buttonId]="idPrefix + 'validate-phone-re-send'" [class.d-none]="countDownCounter >= 0 || hideReSend"
          (click)="reSend()"></app-button>
      </section>

      <p class="counter-text text-center" *ngIf="countDownCounter >= 0">Vuelve a solicitar el código en <strong>{{countDownCounter}} segundos</strong></p>
    </form>
    <div class="change-notification-type">
      <h5>¿No recibiste el código?</h5>
      <p>
        <a (click)="changeMethodOfCode()">Selecciona otras opciones para recibir el código</a>
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="showChangeMethodCode">
    <app-select-method-code
      [sms] = "true"
      [call] = "true"
      [email] = "true"
      [customer] = "selectCustomer"
      (closeSelect) = "closeSelect($event)"
      (sendMethod)="handleSendMethod($event)"
    ></app-select-method-code>
    <a class="support" (click)="openZdWidget()">Contactar a soporte</a>
  </ng-container>

  <app-overlay [isLoading]="false"></app-overlay>
</article>
